import { roomIdsMatch } from "./roomDnd";

// Room list order (web and mobile): the rooms pinned in the sidebar first, in
// their pin order, then the most recent activity. `lastActivityAt` comes from
// /building/my and /building/internalProjects (newest chat message or filed
// email) and is bumped live when a room gets a new message.

export function activityTime(room) {
  const t = room && room.lastActivityAt ? Date.parse(room.lastActivityAt) : NaN;
  return Number.isFinite(t) ? t : 0;
}

/** The room without the list's own markers (listPinned, listKind, listCompany, listTag). */
export function withoutListFields(room) {
  if (!room) return room;
  const { listPinned, listKind, listCompany, listTag, ...rest } = room;
  return rest;
}

/** Newest activity first; stable for rooms without it or with the same time. */
export function sortByActivity(rooms) {
  return (rooms || [])
    .map((room, i) => ({ room, i, t: activityTime(room) }))
    .sort((a, b) => (b.t - a.t) || (a.i - b.i))
    .map((x) => x.room);
}

/**
 * Active rooms: pinned ones on top (flagged `listPinned`), the rest by activity.
 *   pinnedRooms  state.pinnedRooms ([{ id, ... }], in pin order)
 */
export function orderActiveRooms(rooms, pinnedRooms) {
  const list = rooms || [];
  const pins = (Array.isArray(pinnedRooms) ? pinnedRooms : []).filter((p) => p && p.id != null);
  const pinned = [];
  pins.forEach((pin) => {
    const room = list.find((r) => roomIdsMatch(r && r.id, pin.id));
    if (room && !pinned.includes(room)) pinned.push(room);
  });
  const rest = list.filter((r) => !pinned.includes(r));
  return [...pinned.map((room) => ({ ...room, listPinned: true })), ...sortByActivity(rest)];
}
